document.documentElement.classList.remove('no-js');

(function(){
  const routes = window.OvelieRoutes || {cartUrl:'/cart',cartAddUrl:'/cart/add',cartChangeUrl:'/cart/change'};
  const strings = window.OvelieStrings || {
    addToCart:'Add to cart',
    adding:'Adding…',
    soldOut:'Sold out',
    unavailable:'Unavailable',
    addError:'Could not add this item to your cart.'
  };

  function money(cents, currency){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL',{style:'currency',currency:currency || 'EUR'}).format((cents || 0)/100); }
    catch(e){ return '€' + ((cents || 0)/100).toFixed(2).replace('.',','); }
  }

  function variantOrderable(variant){
    if(!variant) return false;
    return variant.available === true || Number(variant.inventory_quantity || 0) > 0 || variant.inventory_policy === 'continue';
  }

  function addBusinessDays(date, amount){
    const result=new Date(date.getFullYear(),date.getMonth(),date.getDate());
    let added=0;
    while(added<amount){
      result.setDate(result.getDate()+1);
      const day=result.getDay();
      if(day!==0 && day!==6) added++;
    }
    return result;
  }

  function formatDeliveryDate(date){
    const lang=document.documentElement.lang || 'nl-NL';
    try{
      return new Intl.DateTimeFormat(lang,{weekday:'short',day:'numeric',month:'short'}).format(date).replace(/\.$/,'');
    }catch(e){
      return date.toLocaleDateString();
    }
  }

  function renderDeliveryEstimates(){
    const now=new Date();
    const start=addBusinessDays(now,2);
    const end=addBusinessDays(now,3);
    const range=formatDeliveryDate(start)+' – '+formatDeliveryDate(end);
    document.querySelectorAll('[data-delivery-range]').forEach(el=>{ el.textContent=range; });
  }

  function openCart(){
    const shell=document.querySelector('[data-cart-drawer]'); if(!shell)return;
    shell.classList.add('is-open'); shell.setAttribute('aria-hidden','false'); document.body.classList.add('drawer-open');
    const close=shell.querySelector('[data-cart-close]'); if(close) setTimeout(()=>close.focus(),30);
  }
  function closeCart(){
    const shell=document.querySelector('[data-cart-drawer]'); if(!shell)return;
    shell.classList.remove('is-open'); shell.setAttribute('aria-hidden','true'); document.body.classList.remove('drawer-open');
  }
  async function refreshCart(openAfter){
    const res=await fetch(routes.cartUrl,{headers:{'X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
    const html=await res.text();
    const doc=new DOMParser().parseFromString(html,'text/html');
    const next=doc.querySelector('[data-cart-drawer]');
    const current=document.querySelector('[data-cart-drawer]');
    if(next && current) current.innerHTML=next.innerHTML;
    const nextCount=doc.querySelector('[data-cart-count]');
    document.querySelectorAll('[data-cart-count]').forEach(el=>{
      const count=nextCount ? nextCount.textContent.trim() : '0';
      el.textContent=count; el.classList.toggle('is-empty',count==='0');
    });
    renderDeliveryEstimates();
    if(openAfter) openCart();
  }

  document.addEventListener('click', async function(e){
    const open=e.target.closest('[data-cart-open]'); if(open){e.preventDefault();openCart();return;}
    const close=e.target.closest('[data-cart-close]'); if(close){e.preventDefault();closeCart();return;}

    const qtyWrap=e.target.closest('[data-quantity-control]');
    if(qtyWrap){
      const input=qtyWrap.querySelector('input[type="number"]');
      if(e.target.closest('[data-qty-minus]')){e.preventDefault();input.value=Math.max(parseInt(input.min||'1',10),parseInt(input.value||'1',10)-1);return;}
      if(e.target.closest('[data-qty-plus]')){e.preventDefault();input.value=parseInt(input.value||'1',10)+1;return;}
    }

    const cartAction=e.target.closest('[data-cart-line-action]');
    if(cartAction){
      e.preventDefault();
      const item=cartAction.closest('[data-cart-item]'); if(!item)return;
      const key=item.dataset.key; const current=parseInt(item.dataset.quantity||'1',10); const action=cartAction.dataset.cartLineAction;
      let quantity=action==='increase'?current+1:action==='decrease'?Math.max(0,current-1):0;
      cartAction.disabled=true;
      try{
        await fetch(routes.cartChangeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity})});
        await refreshCart(true);
      }catch(err){console.error(err);cartAction.disabled=false;}
      return;
    }

    const thumb=e.target.closest('[data-gallery-thumb]');
    if(thumb){
      const gallery=thumb.closest('[data-product-gallery]'); const main=gallery && gallery.querySelector('[data-product-main-image]');
      if(main && thumb.dataset.imageSrc){ main.src=thumb.dataset.imageSrc; main.removeAttribute('srcset'); }
      gallery && gallery.querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.toggle('is-active',t===thumb));
      return;
    }

    const serviceOpen=e.target.closest('[data-service-open]');
    if(serviceOpen){
      e.preventDefault();
      const key=serviceOpen.dataset.serviceOpen;
      const panel=document.querySelector('[data-service-panel="'+key+'"]');
      if(panel){panel.hidden=false;document.body.classList.add('modal-open');const c=panel.querySelector('[data-service-close]');if(c)setTimeout(()=>c.focus(),20);} return;
    }
    const serviceClose=e.target.closest('[data-service-close]');
    if(serviceClose){
      e.preventDefault();
      const panel=serviceClose.closest('[data-service-panel]');
      if(panel){panel.hidden=true;document.body.classList.remove('modal-open');} return;
    }

    const sizeOpen=e.target.closest('[data-size-guide-open]');
    if(sizeOpen){
      const modal=document.querySelector('[data-size-guide-modal]'); if(modal){modal.hidden=false;document.body.classList.add('modal-open'); const c=modal.querySelector('[data-size-guide-close]'); if(c)setTimeout(()=>c.focus(),20);} return;
    }
    const sizeClose=e.target.closest('[data-size-guide-close]');
    if(sizeClose){ const modal=sizeClose.closest('[data-size-guide-modal]'); if(modal){modal.hidden=true;document.body.classList.remove('modal-open');} return; }
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      closeCart();
      const servicePanel=document.querySelector('[data-service-panel]:not([hidden])'); if(servicePanel){servicePanel.hidden=true;document.body.classList.remove('modal-open');}
      const modal=document.querySelector('[data-size-guide-modal]:not([hidden])'); if(modal){modal.hidden=true;document.body.classList.remove('modal-open');}
    }
  });

  document.addEventListener('change',function(e){
    const form=e.target.closest('[data-product-form]'); if(!form || !e.target.matches('[data-option-value]'))return;
    const groups=[...form.querySelectorAll('[data-option-group]')];
    const values=groups.map(g=>{const checked=g.querySelector('[data-option-value]:checked');return checked?checked.value:null;});
    const data=form.querySelector('[data-variants]'); if(!data)return;
    const variants=JSON.parse(data.textContent); const match=variants.find(v=>v.options.every((o,i)=>o===values[i]));
    const root=form.closest('[data-product-root]'); const currency=root?root.dataset.currency:'EUR';
    const btn=form.querySelector('[data-add-to-cart]'); const msg=form.querySelector('[data-product-message]');
    if(!match){ if(btn){btn.disabled=true;btn.textContent=strings.unavailable;} return; }
    form.querySelector('[data-variant-id]').value=match.id;
    const orderable=variantOrderable(match);
    if(btn){btn.disabled=!orderable;btn.textContent=orderable?strings.addToCart:strings.soldOut;}
    if(msg){msg.hidden=true;msg.textContent='';}
    const price=root && root.querySelector('[data-current-price]'); if(price)price.textContent=money(match.price,currency);
    const compare=root && root.querySelector('[data-compare-price]'); const badge=root && root.querySelector('[data-sale-badge]');
    const onSale=match.compare_at_price && match.compare_at_price>match.price;
    if(compare){compare.textContent=onSale?money(match.compare_at_price,currency):'';compare.classList.toggle('is-hidden',!onSale);}
    if(badge)badge.classList.toggle('is-hidden',!onSale);
    if(history.replaceState){const u=new URL(window.location.href);u.searchParams.set('variant',match.id);history.replaceState({},'',u);}
  });

  document.addEventListener('submit',async function(e){
    const form=e.target.closest('[data-product-form]'); if(!form)return;
    e.preventDefault(); const btn=form.querySelector('[data-add-to-cart]'); const msg=form.querySelector('[data-product-message]');
    if(btn){btn.disabled=true;btn.classList.add('is-loading');btn.textContent=strings.adding;}
    try{
      const res=await fetch(routes.cartAddUrl+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',body:new FormData(form)});
      const json=await res.json(); if(!res.ok)throw new Error(json.description||strings.addError);
      await refreshCart(true);
      if(btn){
        btn.classList.remove('is-loading');
        const data=form.querySelector('[data-variants]');
        const id=Number(form.querySelector('[data-variant-id]')?.value || 0);
        const currentVariant=data ? JSON.parse(data.textContent).find(v=>Number(v.id)===id) : null;
        const orderable=variantOrderable(currentVariant);
        btn.disabled=!orderable;
        btn.textContent=orderable?strings.addToCart:strings.soldOut;
      }
    }catch(err){
      if(btn){
        btn.classList.remove('is-loading');
        const data=form.querySelector('[data-variants]');
        const id=Number(form.querySelector('[data-variant-id]')?.value || 0);
        const currentVariant=data ? JSON.parse(data.textContent).find(v=>Number(v.id)===id) : null;
        const orderable=variantOrderable(currentVariant);
        btn.disabled=!orderable;
        btn.textContent=orderable?strings.addToCart:strings.soldOut;
      }
      if(msg){msg.textContent=err.message;msg.hidden=false;}
    }
  });

  renderDeliveryEstimates();
})();